import React from 'react';
import './CustomTable.css';
import { TableHeadData } from '../../config';
import CustomPagination from '../pagination/CustomPagination';
import { getNestedValue } from '../../utils/commanUtil';
import TruncatedListModal from '../TruncatedListModal/TruncatedListModal';

interface CustomTableProps {
    data: any[];
    columns: TableHeadData[];
    handleView?: (detail: any) => void;
    startIndex: number;
    pageSize: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (size: number) => void;
    isLoading: boolean;
    totalItems: number;
    currentPage: number;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
    isShowPopUp?: boolean;
    setSortConfig?: React.Dispatch<React.SetStateAction<any>>;
    handleShowPopUp?: (detail: any) => void;
    handleNavigation?: (detail: any) => void;
    sortConfig?: any;
}

const CustomTable: React.FC<CustomTableProps> = ({
    data,
    columns,
    handleView,
    startIndex,
    pageSize,
    onPageChange,
    onPageSizeChange,
    isLoading,
    currentPage,
    totalItems,
    setCurrentPage,
    isShowPopUp,
    handleNavigation,
    setSortConfig,
    handleShowPopUp,
    sortConfig
}) => {
    const currentData = data;
    const renderRows = (rows: any[], columns: TableHeadData[]) => {
        return rows.map((row) => (
            <React.Fragment key={row.eventId}>
                <tr style={{ color: '#003764' }}>
                    {columns.map((column) => {
                        const cellValue = getNestedValue(row, column.key);

                        return (
                            <td key={`${row.eventId}:${column.key}`}>
                                {/* DETAILS / ACTION COLUMN */}
                                {column.key === 'details' ? (
                                    handleView ? (
                                        <button
                                            onClick={() => handleView(row)}
                                            style={{
                                                border: 'none',
                                                background: 'none',
                                                color: '#003764'
                                            }}
                                        >
                                            <u style={{ fontSize: '16px' }}>
                                                {[
                                                    'Need Revision by Account Manager',
                                                    'Pending Details from Requestor'
                                                ].includes(
                                                    row?.matchMakingStatus
                                                )
                                                    ? 'Edit Request'
                                                    : 'View Details'}
                                            </u>
                                        </button>
                                    ) : (
                                        '-'
                                    )
                                ) : column.key ===
                                  'requestorWantedCategoriesToBeConnected' ? (
                                    (() => {
                                        if (
                                            Array.isArray(
                                                row.requestedService
                                            ) &&
                                            row.requestedService?.length
                                        ) {
                                            const items = row.requestedService
                                                .map((item: any) => {
                                                    if (
                                                        item?.key === 'others'
                                                    ) {
                                                        return `Others (${row.otherRequestedService})`;
                                                    }

                                                    return item?.name;
                                                })
                                                .filter(Boolean);

                                            const names = items.join(', ');

                                            return (
                                                <TruncatedListModal
                                                    value={names}
                                                    items={items}
                                                    label={column.name}
                                                    maxToShowItem={2}
                                                />
                                            );
                                        }

                                        return '-';
                                    })()
                                ) : (
                                    /* NORMAL DATA RENDERING */
                                    <>
                                        {Array.isArray(cellValue)
                                            ? cellValue
                                                  .map(
                                                      (item: {
                                                          name: string;
                                                      }) => item.name
                                                  )
                                                  .join(', ')
                                            : (cellValue?.name ??
                                              cellValue ??
                                              '-')}
                                    </>
                                )}
                            </td>
                        );
                    })}
                </tr>
            </React.Fragment>
        ));
    };

    return (
        <>
            {isLoading ? (
                <div>Loading...</div>
            ) : (
                <div className="customer-table-wrapper">
                    <div className="table-responsive">
                        <table
                            className="table table-autofit show-quick-actions-on-hover table-hover table-striped table-valign-middle"
                            aria-label="Drive"
                            style={{ tableLayout: 'fixed' }}
                        >
                            <thead>
                                <tr>
                                    {columns.map((column) => {
                                        const isSortable =
                                            column.key !== 'createdBy' &&
                                            column.key !== 'industry' &&
                                            column.key !== 'details' &&
                                            column.key !== 'totalServices' &&
                                            column.key !== 'subscriptions';
                                        return (
                                            <th
                                                key={column.key}
                                                style={{
                                                    cursor: isSortable
                                                        ? 'pointer'
                                                        : 'default'
                                                }}
                                                onClick={() => {
                                                    if (!isSortable) return;
                                                    setSortConfig &&
                                                        setSortConfig(
                                                            (prev: any) => ({
                                                                key: column.key,
                                                                direction:
                                                                    prev.key ===
                                                                        column.key &&
                                                                    prev.direction ===
                                                                        'asc'
                                                                        ? 'desc'
                                                                        : 'asc'
                                                            })
                                                        );
                                                }}
                                            >
                                                {column.name}{' '}
                                            </th>
                                        );
                                    })}
                                </tr>
                            </thead>
                            <tbody>{renderRows(currentData, columns)}</tbody>
                        </table>
                        <CustomPagination
                            defaultActive={startIndex}
                            totalItems={totalItems}
                            initialDelta={pageSize} // Set initial delta here
                            onPageChange={onPageChange}
                            onDeltaChange={onPageSizeChange}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default CustomTable;
